<template>
    <div id="app">
        <v-app id="inspire">   
            <v-img dark class="blue" height="200">
                <v-container>
                    <v-layout>
                        <v-container>
                            <v-flex xs6 right>
                            <v-text-field solo flat hide-details label="Search" v-model="search" append-icon="search" clearable></v-text-field>
                            </v-flex>
                        </v-container>
                    </v-layout>

                    <v-layout>
                        <v-list-tile class="white--text" @click="status=true">
                            <v-list-tile-content class="body-1 font-weight-medium">
                                <v-list-tile-title>Scheduled Mechanics</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-chip dark small :color="scheduledColor"><b>{{scheduledMechanics.length}}</b></v-chip>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile class="white--text" @click="status=false">
                            <v-list-tile-content class="body-1 font-weight-medium">
                                <v-list-tile-title>Walk-in Mechanics</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-chip dark small :color="walkinColor"><b>{{walkinMechanics.length}}</b></v-chip>
                            </v-list-tile-action>
                        </v-list-tile>

                        <v-list-tile class="white--text" @click="status='InActive'">
                            <v-list-tile-content class="body-1 font-weight-medium">
                                <v-list-tile-title>Inactive Mechanics</v-list-tile-title>
                            </v-list-tile-content>

                            <v-list-tile-action>
                                <v-chip dark small :color="inactiveColor"><b>{{inactiveMechanics.length}}</b></v-chip>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-layout>
                </v-container>
            </v-img>

            <v-container grid-list-md class="pt-0">
                <v-layout>
                    <v-spacer></v-spacer>
                    <v-flex xs2 >
                        <v-btn color="red accent-4" dark @click="mechanicDialog=true, type=1">NEW MECHANIC</v-btn>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-flex xs12>
                        <v-data-table v-if="status==true" :search="search" :headers="headers" :items="scheduledMechanics" class="elevation-1">
                            <template v-slot:items="props">
                                <td>{{ props.item.branch }}</td>
                                <td class="text-xs-left">{{ props.item.branchCode }}</td>
                                <td class="text-xs-left">{{ props.item.name }}</td>
                                <td class="text-xs-left">{{ props.item.email }}</td>
                                <td class="text-xs-left">{{ props.item.mobileNumber }}</td>
                                <td class="text-xs-left">{{ props.item.creationDate }}</td>
                                <td class="text-xs-left">{{ props.item.modifiedDate }}</td>
                                <td class="justify-center">
                                    <v-icon small @click="updateMechanicRequest(props.item)">edit</v-icon>
                                </td>
                            </template>
                            
                            <template v-slot:no-data>
                                <v-alert :value="true" color="grey">
                                    No Mechanics Available
                                </v-alert>
                            </template>

                            <template v-slot:no-results>
                                <v-alert :value="true" color="error" icon="warning">
                                    Your search for "{{ search }}" found no results.
                                </v-alert>
                            </template>
                        </v-data-table>

                        <v-data-table v-else-if="status==false" :search="search" :headers="headers" :items="walkinMechanics" class="elevation-1">
                            <template v-slot:items="props">
                                <td>{{ props.item.branch }}</td>
                                <td class="text-xs-left">{{ props.item.branchCode }}</td>
                                <td class="text-xs-left">{{ props.item.name }}</td>
                                <td class="text-xs-left">{{ props.item.email }}</td>
                                <td class="text-xs-left">{{ props.item.mobileNumber }}</td>
                                <td class="text-xs-left">{{ props.item.creationDate }}</td>
                                <td class="text-xs-left">{{ props.item.modifiedDate }}</td>
                                <td class="justify-center">
                                    <v-icon small @click="updateMechanicRequest(props.item)">edit</v-icon>
                                </td>
                            </template>
                            
                            <template v-slot:no-data>
                                <v-alert :value="true" color="grey">
                                    No Mechanics Available
                                </v-alert>
                            </template>

                            <template v-slot:no-results>
                                <v-alert :value="true" color="error" icon="warning">
                                    Your search for "{{ search }}" found no results.
                                </v-alert>
                            </template>
                        </v-data-table>

                        <v-data-table v-else-if="status=='InActive'" :search="search" :headers="inactiveHeader" :items="inactiveMechanics" class="elevation-1">
                            <template v-slot:items="props">
                                <td>{{ props.item.branch }}</td>
                                <td class="text-xs-left">{{ props.item.branchCode }}</td>
                                <td class="text-xs-left">{{ props.item.name }}</td>
                                <td class="text-xs-left">{{ props.item.email }}</td>
                                <td class="text-xs-left">{{ props.item.mobileNumber }}</td>
                                <td class="text-xs-left">{{ props.item.creationDate }}</td>
                                <td class="text-xs-left">{{ props.item.inactiveDate }}</td>
                                <td class="justify-center">
                                    <v-icon small @click="updateMechanicRequest(props.item)">edit</v-icon>
                                </td>
                            </template> 
                            <template v-slot:no-data>
                                <v-alert :value="true" color="grey">
                                    No Mechanics Available
                                </v-alert>
                            </template>

                            <template v-slot:no-results>
                                <v-alert :value="true" color="error" icon="warning">
                                    Your search for "{{ search }}" found no results.
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-layout>

                <v-layout>
                    <v-dialog v-model="mechanicDialog" persistent max-width="600px">
                        <v-card>
                            <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg" height="70">
                                <v-container>
                                    <v-layout>
                                        <h4 v-if="type==0" class="subheading font-weight-medium">UPDATE MECHANIC</h4>
                                        <h4 v-else class="subheading font-weight-medium">NEW MECHANIC</h4>
                                    </v-layout>
                                </v-container>
                            </v-parallax>

                            <v-container grid-list>
                                <v-container>
                                    <v-layout row wrap>
                                        <v-flex xs12>
                                            <v-text-field label="Name*" hide-details v-model='mechanicDetails.name'></v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field v-model="mechanicDetails.branch" label="Branch" readonly persistent-hint hide-details leave-absolute>
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field v-model="mechanicDetails.branchCode" label="BranchCode" readonly persistent-hint hide-details leave-absolute>
                                            </v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-text-field label="Email*" hide-details v-model='mechanicDetails.email' required></v-text-field>
                                        </v-flex>

                                        <v-flex xs3>
                                            <v-text-field class="pr-0" label="Country Code" :value="'+63'" readonly></v-text-field>
                                        </v-flex>

                                        <v-flex xs9>
                                            <v-text-field class="pl-0" v-model="mechanicDetails.mobileNumber" :rules="mobileChecker" label="Mobile Number*" maxlength="10" prepend-inner-icon="phone" type="text" required hint=" ex.9123456789"></v-text-field>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-radio-group v-model="mechanicDetails.tag" :mandatory="false" row>
                                                <v-radio label="Schedule" color="success" :value="true"></v-radio>
                                                <v-radio label="Walk-in" color="orange darken-4" :value="false"></v-radio>
                                            </v-radio-group>
                                        </v-flex>

                                        <v-flex xs12>
                                            <v-radio-group v-model="mechanicDetails.status" :mandatory="false" row>
                                                <v-radio label="Active" color="success" value="Active"></v-radio>
                                                <v-radio label="Inactive" color="orange darken-4" value="InActive"></v-radio>
                                            </v-radio-group>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <v-layout justify-center>
                                    <v-btn dark color="red accent-4" @click="mechanicDialog=false,reload()">Cancel</v-btn>
                                    <v-btn v-if="type==0" dark color="blue darken-4" @click="updateMechanic()">SAVE</v-btn>
                                    <v-btn v-else color="blue darken-4" dark @click="saveNewMechanic()">SAVE</v-btn>
                                </v-layout>
                            </v-container>
                        </v-card>
                    </v-dialog>
                </v-layout>
            </v-container> 
            <Snackbar v-model="snackbar.show" :type="snackbar.type" :message="snackbar.message" />
            <Progress v-model="progress.show" :message="progress.message" />
        </v-app>
    </div>    
</template>

<script>
import firebase from "firebase"
import {db} from '../main'
import { mapGetters, mapState } from "vuex"
import moment from 'moment'
import Progress from '../extras/Progress.vue'
import Snackbar from '../extras/Snackbar.vue'
export default {
    components: {
        Snackbar,
        Progress
    },
    data: () => ({
        search: "",
        status: true,
        mechanics: [],
        activeMechanics: [],
        scheduledMechanics: [],
        walkinMechanics: [],
        inactiveMechanics: [],
        headers: [
            { text: 'Branch', value: 'branch',  sortable: true  },
             { text: 'Branch Code', value: 'branchCode',  sortable: true  },
            { text: 'Name', align: 'left', sortable: false, value: 'name'},
            { text: 'Email', value: 'email',  sortable: false  },
            { text: 'Mobile Number', value: 'mobileNumber',  sortable: false  },
            { text: 'Creation Date', value: 'creationDate',  sortable: false  },
            { text: 'Modified Date', value: 'modifiedDate',  sortable: false  },
            { text: 'Actions', sortable: false }
        ],
        inactiveHeader: [
            { text: 'Branch', value: 'branch',  sortable: true  },
             { text: 'Branch Code', value: 'branchCode',  sortable: true  },
            { text: 'Name', align: 'left', sortable: false, value: 'name'},
            { text: 'Email', value: 'email',  sortable: false  },
            { text: 'Mobile Number', value: 'mobileNumber',  sortable: false  },
            { text: 'Creation Date', value: 'creationDate',  sortable: false  },
            { text: 'Inactive Date', value: 'modifiedDate',  sortable: false  },
            { text: 'Actions', sortable: false }
        ],
        mechanicDetails: {"status":"Active","tag":false},
        inactiveColor: "grey",
        activeColor: "grey",
        scheduledColor: "red",
        walkinColor: "grey",
        mechanicDialog: false,
        emailRules: [ v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail must be valid'],
        mobileChecker: [v => v.length == 10|| 'Mobile number must be valid'],
        mechanicTime: [],
        type: 0,
        branch: "",
        branchCode: "",
        branchId: "",
        snackbar: {
            responseMessage: "",
            show: false,
            type: "success"
        },
        progress: {
            message: "",
            show: false,
        },
    }),

    methods: {
        showSnackbarMessage(message, success = true) {
            this.snackbar.type = success ? "success" : "error"
            this.snackbar.message = message
            this.snackbar.show = true
        },
        showProgress(message) {
            this.progress.message = message
            this.progress.show = true
        },
        stopProgress() {
            this.progress.show = false
        },
        async fetchSchedule(){
            let self = this
            let count = 0
            self.mechanicTime = []

            await db.collection("Settings"+self.$stage).doc("Schedule")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc){
                    self.mechanicTime.push(doc.data().time)
                    count ++

                    if (count === querySnapshot.docs.length) {
                        self.mechanicTime.sort(function (timeA, timeB) {
                            return new Date('1970/01/01 ' + timeA) - new Date('1970/01/01 ' + timeB);
                        })
                    }
                })
            }).catch(function(error){
                console.log(error)
            })
        },
        async getAssign() {
            let self = this
            self.showProgress("Loading Mechanics...")
            await firebase.auth().onAuthStateChanged(async function(user) {
                await db.collection("Users"+self.$stage).doc(user.uid)
                .get().then(function(doc) {
                    self.branchId = doc.data().assignId
                    self.branch = doc.data().assign.split('_')[1].trim()
                    self.branchCode = doc.data().assign.split('_')[0].trim()
                    self.mechanicDetails.branch = self.branch
                    self.mechanicDetails.branchCode = self.branchCode
                }).then(async function() {
                    await self.fetchMechanics()
                }).catch(function(error){
                    console.log(error)
                })
            })
        },
        async fetchMechanics() {
            let self = this
            self.showProgress("Loading Mechanics...")
            self.mechanics = []
            self.walkinMechanics = []
            self.scheduledMechanics = []
            self.inactiveMechanics = []

            await db.collection("Mechanics"+self.$stage)
            .get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (self.branch == doc.data().branch) {
                        self.mechanics.push(doc.data())
                    }
                })

                self.mechanics.forEach(function(list){
                    if(list.status == "InActive") {
                        self.inactiveMechanics.push(list)
                    }
                })

                self.mechanics.forEach(function(list){
                    if(list.tag == true && list.status == "Active") {
                        self.scheduledMechanics.push(list)
                    }
                })

                self.mechanics.forEach(function(list){
                    if(list.tag == false && list.status == "Active") {
                        self.walkinMechanics.push(list)
                    }
                })
                self.mechanicDialog = false
                self.stopProgress()
            }).catch(function(error) {console.log(error)})
        },
        async saveNewMechanic() {
            let self = this
            if (self.mechanicDetails.email && self.mechanicDetails.name && self.mechanicDetails.mobileNumber.length == 10) {
                let timeStampId = new Date().getTime().toString()
                self.showProgress("Saving...")
                await db.collection("Mechanics"+self.$stage).doc(timeStampId)
                .set({
                    branchId: self.branchId,
                    name: self.mechanicDetails.name,
                    branch: self.mechanicDetails.branch,
                    branchCode: self.mechanicDetails.branchCode,
                    email: self.mechanicDetails.email,
                    mobileNumber: self.mechanicDetails.mobileNumber,
                    status: self.mechanicDetails.status,
                    tag: self.mechanicDetails.tag,
                    time: self.mechanicTime,
                    id: timeStampId,
                    creationDate: moment().format('MMMM Do YYYY, h:mm:ss a'),
                    modifiedDate: "",
                    inactiveDate: "",
                })
                .then(function() {
                    setTimeout(() => {
                        self.showSnackbarMessage("Successfully Saved", true)
                        self.mechanicDetails = {"status":"Active", "branch": self.branch, "branchCode": self.branchCode, "tag":false}
                        self.fetchMechanics()
                    }, 1000)
                }).catch(function(error) {
                    console.log(error)
                })
            } else {
                self.showSnackbarMessage("Please fill-up all details", false)
            }
        },
        async updateMechanicRequest(mechanic) {
            let self = this 
            self.type = 0
            await db.collection("Mechanics"+self.$stage).doc(mechanic.id)
            .get().then(function(doc) {
                self.mechanicDetails = doc.data()
            }).then(function() {
                self.mechanicDialog = true
            })
        },
        async updateMechanic() {
            let self = this
            var inactiveData = {
                branchId: self.branchId,
                name: self.mechanicDetails.name,
                branch: self.mechanicDetails.branch,
                branchCode: self.mechanicDetails.branchCode,
                email: self.mechanicDetails.email,
                mobileNumber: self.mechanicDetails.mobileNumber,
                status: self.mechanicDetails.status,
                tag: self.mechanicDetails.tag,
                inactiveDate: moment().format('MMMM Do YYYY, h:mm:ss a')
            }
            var activeData = {
                branchId: self.branchId,
                name: self.mechanicDetails.name,
                branch: self.mechanicDetails.branch,
                branchCode: self.mechanicDetails.branchCode,
                email: self.mechanicDetails.email,
                mobileNumber: self.mechanicDetails.mobileNumber,
                status: self.mechanicDetails.status,
                tag: self.mechanicDetails.tag,
                modifiedDate: moment().format('MMMM Do YYYY, h:mm:ss a')
            }
            self.mechanicDetails.status == "InActive" ? await self.updateMechanicValidation(inactiveData) : await self.updateMechanicValidation(activeData)
        },
        async updateMechanicValidation(data) {
            console.log(data)
            let self = this
            if (self.mechanicDetails.mobileNumber.length == 10) {
                self.showProgress("Updating.....")
                await db.collection("Mechanics"+self.$stage).doc(self.mechanicDetails.id)
                .update(data)
                .then(function() {
                    setTimeout(() => {
                        self.showSnackbarMessage("Successfully Updated", true)
                        self.mechanicDetails = {"status":"Active", "branch": self.branch, "branchCode": self.branchCode, "tag":false}
                        self.fetchMechanics()
                    }, 1000)
                }).catch(function(error){
                    console.log(error)
                })
            } else {
                self.showSnackbarMessage("Invalid mobile number", false)
            }
        },
        reload() {
            window.location.reload()
        },
    },

    async mounted() {
        let self = this
        await self.getAssign()
        await self.fetchSchedule()
    },

    watch: {
        status(val) {
            if(this.status == "InActive"){
                this.inactiveColor = "red"
                this.walkinColor = "grey"
                this.scheduledColor = "grey"
            }else if(this.status == true){
                this.scheduledColor = "red"
                this.walkinColor = "grey"
                this.inactiveColor = "grey"
            } else if(this.status == false){
                this.walkinColor = "red"
                this.scheduledColor = "grey"
                this.inactiveColor = "grey"
            }
        },
    },
    
}
</script>

